export default __webpack_public_path__ + "static/media/Breast support facts.36829c34.png";